/*
 ****************************************************************
 ******************    ALL APP CONSTANTS   **********************
 ****************************************************************
 */

/**
 * extending app global constants for page loading
 * @constant DEFAULT_PAGINATION default value
 * @constant LANGUAGE_DEFAULT default value
 */
export const DEFAULT_PAGINATION: number = 8;
export const LANGUAGE_DEFAULT: string = 'en';

/**
 * extending app global constants
 * @constant COLOR_SWAP_TRANSITION_DURATION default value
 */
export const COLOR_SWAP_TRANSITION_DURATION: number = 350;

export const MAX_NUM_OF_LIKES = 16;
